import { render, staticRenderFns } from "./VvBoxSlider.vue?vue&type=template&id=72629e32&scoped=true&"
import script from "./VvBoxSlider.vue?vue&type=script&lang=js&"
export * from "./VvBoxSlider.vue?vue&type=script&lang=js&"
import style0 from "./VvBoxSlider.vue?vue&type=style&index=0&id=72629e32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72629e32",
  null
  
)

export default component.exports